<div class="stiiizy-wide-product-information" [style.color]="viewModel.bodyTextColor$ | async">
  <div class="background-content" [style.background-color]="viewModel.stiiizyCardBackgroundColor$ | async"></div>
  <div class="logo-container">
    <img
      *ngIf="cardData | getVariantAssetForCard | async as variantAsset; else brandName"
      appImage
      class="brand-logo"
      [asset]="variantAsset"
      src=""
      alt="" />
    <ng-template #brandName>
      <div
        *ngIf="cardData | sectionRowViewModelBasicMethod: 'getBrand' as brand"
        appPrintCardScaleDownText
        [transparentWhileScaling]="viewModel.viewingInLiveView$ | async"
        [maxHeightInPx]="102"
        [startScalingAfterNMillisecondsAfterViewInit]="500"
        class="product-card-brand"
        [style.color]="viewModel.headerTextColor$ | async">
        {{ brand }}
      </div>
    </ng-template>
  </div>

  <div class="product-info-container">
    <div
      *ngIf="cardData | sectionRowViewModelBasicMethod: 'getRowTitle' as title"
      #title
      class="product-card-variant-title"
      [style.color]="viewModel.headerTextColor$ | async"
      appPrintCardScaleDownText
      [maxHeightInPx]="20"
      [lineHeightScaleVsFontSize]="1"
      [startScalingAfterNMillisecondsAfterViewInit]="500"
      [transparentWhileScalingDebounceTimeInMilliseconds]="501"
      [transparentWhileScaling]="viewModel.viewingInLiveView$ | async">
      {{ title }}
    </div>
    <div *ngIf="viewModel.showCannabinoids$ | async" #cannabinoids class="cannabinoids">
      <div *ngFor="let property of viewModel.propertiesBasedOnPools$ | async" class="product-cannabinoid">
        <span>{{ property.title }}</span> {{ property.value }}
      </div>
    </div>
    <div class="size-and-label">
      <div
        *ngIf="viewModel | getExpandedGridSize: (viewModel.spoofedColViewModel$ | async) : true : false | async as size"
        class="product-card-size">
        {{ size }}
      </div>
      <app-label-inflator
        class="print-card-label"
        [columnLabel]="false"
        [labelComponentInterface]="cardData"
        [reset]="false">
      </app-label-inflator>
    </div>
    <div class="bottom-content">
      <div class="product-card-price" [style.color]="viewModel.bodyTextColor$ | async">
        <div
          *ngIf="(cardData?.menu | printCardMenuBasicMethod: 'getNumberOfBadgesForVariant' : cardData) > 0"
          class="badge-container">
          <img
            *ngFor="let variantBadge of cardData | printCardBadges"
            appImage
            class="badge"
            [asset]="variantBadge?.image"
            alt="badge"
            src="" />
        </div>
        <app-column-primary-price
          [menu]="viewModel.cardStackMenu$ | async"
          [section]="viewModel.cardStack$ | async"
          [colVm]="viewModel.spoofedColViewModel$ | async"
          [rowVm]="viewModel.cardData$ | async"
          [locConfig]="viewModel.locationConfig$ | async"
          [locationId]="viewModel.locationId$ | async"
          [productStylingVm]="viewModel">
        </app-column-primary-price>
      </div>
    </div>
  </div>
</div>
